import { render, staticRenderFns } from "./UrbanismRegulationsPanel.vue?vue&type=template&id=5419696f&scoped=true&"
import script from "./UrbanismRegulationsPanel.vue?vue&type=script&lang=js&"
export * from "./UrbanismRegulationsPanel.vue?vue&type=script&lang=js&"
import style0 from "./UrbanismRegulationsPanel.vue?vue&type=style&index=0&id=5419696f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419696f",
  null
  
)

export default component.exports